import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/Users/H P/AppData/Roaming/npm/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "2048.html",
    "revision": "26123a50d22d8f01031bcf0143afb316"
  },
  {
    "url": "2082.html",
    "revision": "66637c11f9c04f8ae66428138597f7ea"
  },
  {
    "url": "60-business-ideas.html",
    "revision": "ee5d778f34ff7987d1c97241417e21f7"
  },
  {
    "url": "about.html",
    "revision": "2f87f8689bd725855d60c94b145a830e"
  },
  {
    "url": "activity-logger.html",
    "revision": "b4c26e5fefe6b113fb4f3f3a9af8c758"
  },
  {
    "url": "africa-money-convert.html",
    "revision": "6d47b700dec987d5bfc89c31bd518671"
  },
  {
    "url": "air-quality.html",
    "revision": "26048e364f04f78c0aaa59f9503e3c1f"
  },
  {
    "url": "alcohol-tester.html",
    "revision": "338d6fe25b67fe05ba5048ec50b57390"
  },
  {
    "url": "army-warfare.html",
    "revision": "22936cd4e28a96d05be81336b4ba20d8"
  },
  {
    "url": "asmr.html",
    "revision": "12a80af1dcd0412c25bd74557c26bbe7"
  },
  {
    "url": "ball-maze-shooter.html",
    "revision": "5580fe8cd862937243c0249e6b8622ed"
  },
  {
    "url": "banana-copter-swing.html",
    "revision": "59a755308de0f45436a2ee2353a085a7"
  },
  {
    "url": "barcode-maker.html",
    "revision": "6eb039db88ddb4de6ae08c78779227b9"
  },
  {
    "url": "base-converter.html",
    "revision": "e4276cfe64589aa70ab3406f9c5587ec"
  },
  {
    "url": "base-kobi-dynamic.html",
    "revision": "34b05dbbbf38243877b41cd0b4e2ae33"
  },
  {
    "url": "basketball-dunk.html",
    "revision": "4743d93f39bf5e1017cc8ef9ee3c9b2e"
  },
  {
    "url": "battleship.html",
    "revision": "9bde7f8379513e2ad00a5d16242184c5"
  },
  {
    "url": "bazar.html",
    "revision": "b26c19292184c65bceba067928af8da8"
  },
  {
    "url": "bd-medicines.html",
    "revision": "a7142aea94aee5121b06d033adc3df1f"
  },
  {
    "url": "be-in-contact.html",
    "revision": "d9bb72369c0e511837cabdaded7841a2"
  },
  {
    "url": "be-safe.html",
    "revision": "4f131a094a297275e4c4789cc528269f"
  },
  {
    "url": "beer-pipe-network.html",
    "revision": "b656b7ae42444e4ed0f6b74d61c1b022"
  },
  {
    "url": "befive-jackpot.html",
    "revision": "317f67121b2c774f1358f65553353235"
  },
  {
    "url": "bhagavad-gita.html",
    "revision": "32994b70a7c740b1e62792df0d501e62"
  },
  {
    "url": "bing-wallpaper.html",
    "revision": "3666f774cbbbb04088b04811d3c69fc3"
  },
  {
    "url": "bitcoin.html",
    "revision": "e3575e3c273b93f26a75995bd02046b9"
  },
  {
    "url": "blackjack.html",
    "revision": "71ef1a93e637655f1d04eebc1ed59c96"
  },
  {
    "url": "bmi-calculator.html",
    "revision": "e9eda9e09ba4e51f4e5b0255cf76f272"
  },
  {
    "url": "body-weight-calculator.html",
    "revision": "deda7271dc19bdcc489a7a0608f8ba1a"
  },
  {
    "url": "boomplay.html",
    "revision": "afffb27b668ae318cf4ef3fdd5a21f2b"
  },
  {
    "url": "boost.html",
    "revision": "b7f8441be8a3ab3772db72d2f002e208"
  },
  {
    "url": "boxing-arena-fighter.html",
    "revision": "d4be6a11d6dd15d44913a3ff6b1da39e"
  },
  {
    "url": "brain-waves.html",
    "revision": "52c79dde2a7790a274c827e9faa3de50"
  },
  {
    "url": "breathe.html",
    "revision": "93dd8bc229ba6c33c6cb50b1ae9145cf"
  },
  {
    "url": "call-center-interview-questions.html",
    "revision": "a0537dc71d860a3742d3a7fc333e98b4"
  },
  {
    "url": "call-ed.html",
    "revision": "ef14653ce8a16c0bdcd734a0b57ed712"
  },
  {
    "url": "car-street-racing.html",
    "revision": "9c75bf6f5a3f99db3e405d328fcc5275"
  },
  {
    "url": "categories/communication-2.html",
    "revision": "f9b4f31b9a29b445532230e9f5a852f4"
  },
  {
    "url": "categories/communication.html",
    "revision": "963ae7cc781cd1a33cbe35abc2b08fc1"
  },
  {
    "url": "categories/education-2.html",
    "revision": "0f5e2c36064312b518aaabec30391708"
  },
  {
    "url": "categories/education-3.html",
    "revision": "a8e7ec2a7c18b4245953be25a7d73e24"
  },
  {
    "url": "categories/education-4.html",
    "revision": "eaaa9a5a900d62f803bbcb2a89fd11c7"
  },
  {
    "url": "categories/education.html",
    "revision": "97a1832e39abb4c2b6ec5fd9dcc677a6"
  },
  {
    "url": "categories/fun-2.html",
    "revision": "3dd386c18222cb88def254a32d6581a6"
  },
  {
    "url": "categories/fun-3.html",
    "revision": "8d3d3717b28d61c990d740abe69b8aad"
  },
  {
    "url": "categories/fun-4.html",
    "revision": "ac668bd0a9813a8fbab0a7a27655c49d"
  },
  {
    "url": "categories/fun-5.html",
    "revision": "ddde6ca12192f120410d238cf01b7384"
  },
  {
    "url": "categories/fun-6.html",
    "revision": "b5214e5103012911fecd1fed9011d79e"
  },
  {
    "url": "categories/fun.html",
    "revision": "18e315b7a4de82e1d438f997f6ed9136"
  },
  {
    "url": "categories/games-10.html",
    "revision": "2049336db02a03f477c83bfd3a71621f"
  },
  {
    "url": "categories/games-2.html",
    "revision": "b95d0d11c3ac471af119517da0d19ff4"
  },
  {
    "url": "categories/games-3.html",
    "revision": "a84feef5a653e7c15432271530062e80"
  },
  {
    "url": "categories/games-4.html",
    "revision": "7b5e85ecdbe5b0324eaa219f739dddf5"
  },
  {
    "url": "categories/games-5.html",
    "revision": "6ff29d308ba4ea6959d8756b9518c4fd"
  },
  {
    "url": "categories/games-6.html",
    "revision": "168fc7ee065b07cb2c01da5768e38878"
  },
  {
    "url": "categories/games-7.html",
    "revision": "6a1b47fadee346fbb2987e7943a69253"
  },
  {
    "url": "categories/games-8.html",
    "revision": "f41bdf2dab5572941cf6ce9d289ab147"
  },
  {
    "url": "categories/games-9.html",
    "revision": "a0603d05ed7892465b0bd6f91f2c1d93"
  },
  {
    "url": "categories/games.html",
    "revision": "4d710826fb48ec97b8d0915d5ee19e07"
  },
  {
    "url": "categories/health-2.html",
    "revision": "8a16f501d8a5e8ab9ba32e304bdf76fa"
  },
  {
    "url": "categories/health-3.html",
    "revision": "9f36bf8ee466fe28c649ecfedea62897"
  },
  {
    "url": "categories/health-4.html",
    "revision": "90cdc9d9d13217bc964c66741d12e739"
  },
  {
    "url": "categories/health.html",
    "revision": "74048f1f93172810a0590f6b85977fd8"
  },
  {
    "url": "categories/money.html",
    "revision": "4fdf35bace745f056ff5573d123a28ad"
  },
  {
    "url": "categories/news.html",
    "revision": "1bf831490886f67a10b07d0672663f57"
  },
  {
    "url": "categories/tools-2.html",
    "revision": "df9d3ab214c1c3571789fd2b5b6dc282"
  },
  {
    "url": "categories/tools-3.html",
    "revision": "b0888bed70fe2502efa706ce71a2af15"
  },
  {
    "url": "categories/tools-4.html",
    "revision": "6761784786ffbe2a1abf4508231a8d18"
  },
  {
    "url": "categories/tools-5.html",
    "revision": "6f583a441c832f7ea57b39bd764d0814"
  },
  {
    "url": "categories/tools-6.html",
    "revision": "2d0ee7b0441b231dfe17b9921b470a5c"
  },
  {
    "url": "categories/tools-7.html",
    "revision": "05f8049a5add0be6b01452b0012bcc00"
  },
  {
    "url": "categories/tools-8.html",
    "revision": "7d1416e7b61b487650b48406d304c53e"
  },
  {
    "url": "categories/tools.html",
    "revision": "e406222cd7197a56dad05bd8873e871d"
  },
  {
    "url": "caveman-adventures.html",
    "revision": "22704373d1d1a5a9a28febdd22f2e2dc"
  },
  {
    "url": "chat-stories.html",
    "revision": "21e9a1de4d5d2efdf28a5b51325961ce"
  },
  {
    "url": "chess.html",
    "revision": "d10a58214ccb8e902bee5fc8f31bd543"
  },
  {
    "url": "chicken-egg-survival.html",
    "revision": "2c1ecdd5743d38163b0c85ddf04d90ef"
  },
  {
    "url": "chuck-norris-jokes.html",
    "revision": "d3fad2cdd2f05c351544b73306fb6c63"
  },
  {
    "url": "circle-line-rhythm.html",
    "revision": "c5b0b5ce55ecb03e2642d99afe505424"
  },
  {
    "url": "clay-disc-shooting.html",
    "revision": "67f4c08bbf67ccb19b53e02fff648a38"
  },
  {
    "url": "color-recognizer.html",
    "revision": "a3c1b2cb5a09823b72f4e51692a57432"
  },
  {
    "url": "color-shape.html",
    "revision": "36501b5e6e56815af79d738d7610f055"
  },
  {
    "url": "colour-blindness.html",
    "revision": "0edcb889a960eb3da64a4fd646990881"
  },
  {
    "url": "colour-recognizer.html",
    "revision": "54190f393b7d4206e6816f871340f3be"
  },
  {
    "url": "connect-the-dots.html",
    "revision": "f7439484d67b8bc7dd8a288e15cfc80f"
  },
  {
    "url": "coronumbers.html",
    "revision": "0e8744aab54a4d9372bee76fabcc60ff"
  },
  {
    "url": "cosmetics.html",
    "revision": "5b6201c3f86644c8800b010e2ac25d47"
  },
  {
    "url": "countries-quiz.html",
    "revision": "ad5c2770687a2548ce2feca31b4571f1"
  },
  {
    "url": "covid-19-stats.html",
    "revision": "b33711c8f9972d9276af96b2076baa09"
  },
  {
    "url": "cross-the-bridge.html",
    "revision": "3318aaf77017b2ee38ec82d9ba7b04b2"
  },
  {
    "url": "daily-inspiration.html",
    "revision": "696c0ea4fc1ea3250aeb079a40493ca6"
  },
  {
    "url": "dailynews.html",
    "revision": "65c512068574819f3063b027240c37db"
  },
  {
    "url": "date-calculator.html",
    "revision": "b6c832b4ed4eb8b7705e6234330ea358"
  },
  {
    "url": "death-star-attack.html",
    "revision": "18ba83e8e389c947263e5b3a5fe6e682"
  },
  {
    "url": "did-you-know.html",
    "revision": "1c7b6ba11a587fc96f06ddfc5d899630"
  },
  {
    "url": "do-not.html",
    "revision": "c5617c813a5baca035328c25199c4b7a"
  },
  {
    "url": "doc-fix-the-mix.html",
    "revision": "e57f65e5f942b3a5f7048047e4dd8c43"
  },
  {
    "url": "docx-reader.html",
    "revision": "fd5831f078e76031be8142f05f5c022a"
  },
  {
    "url": "dominoes.html",
    "revision": "7fa7593391ab75635d5e0caa5037c1c0"
  },
  {
    "url": "drum-kit-music-learning.html",
    "revision": "20ba107efd3576c4142db2a587f50bb0"
  },
  {
    "url": "duck-shooter-classic.html",
    "revision": "964eecde786ee10369f3735085a3c902"
  },
  {
    "url": "easy-money-converter.html",
    "revision": "370e247e4bc59195c48210545f5baad4"
  },
  {
    "url": "easy-translate.html",
    "revision": "b61f27c721273592553ff3ffb700c597"
  },
  {
    "url": "eclipses.html",
    "revision": "1c50b4319393d009f71e1139881a4bea"
  },
  {
    "url": "em-dictionary.html",
    "revision": "c79f4d955e5fece4879184d062398158"
  },
  {
    "url": "english-verbs.html",
    "revision": "1f8e6e9810fa3e7ebbf47dcf458527ec"
  },
  {
    "url": "escape-from-deep-sea.html",
    "revision": "2a7eb31b5a6c3b0e5ea290c3646e5ea5"
  },
  {
    "url": "facebook.html",
    "revision": "cad2b2a5b1eb0bc7d6a45924f0dea5df"
  },
  {
    "url": "fake-call.html",
    "revision": "7bb472421a556c5168d273b25aa23bef"
  },
  {
    "url": "falling-numbers.html",
    "revision": "331400b2ce0a0617e830562c0967d381"
  },
  {
    "url": "fast-freddie.html",
    "revision": "5503f9989cc8b4f9b43838e337fa73cd"
  },
  {
    "url": "filter.html",
    "revision": "489a9337f3029d55d0201a96d434da21"
  },
  {
    "url": "fitness-workout-timer.html",
    "revision": "e2c1494c7663a080a649bec0c89ebfe4"
  },
  {
    "url": "flapnglide.html",
    "revision": "2ca1199c564ac466d7f9ab3de2c1033b"
  },
  {
    "url": "flower-slide-puzzle.html",
    "revision": "5d367e44986b34c5094a331f3d826879"
  },
  {
    "url": "flying-egg-copter.html",
    "revision": "405f6ad05bb6dcb92d989202c83e8d85"
  },
  {
    "url": "food-and-nutrition-2.html",
    "revision": "ee5ea74f56b235acdf5cd5744d447bce"
  },
  {
    "url": "food-and-nutrition.html",
    "revision": "205c821a64a589c25a2046d902139090"
  },
  {
    "url": "formula-life.html",
    "revision": "c071a5a0445cf4a1884e3d2610dc3d3d"
  },
  {
    "url": "fortune-cookie.html",
    "revision": "5d2e676acd494ce8c2bc3d8894afbe57"
  },
  {
    "url": "free-text-reader-2.html",
    "revision": "ab3e9cbec220ecf0e8bee20c8028a9c7"
  },
  {
    "url": "frog-stuck-in-traffic.html",
    "revision": "bbb9b083499a13dfe0500d1b97ff5cbf"
  },
  {
    "url": "frogr.html",
    "revision": "6e0ca25361ec330c28730693c61a062e"
  },
  {
    "url": "fruit-slice-and-dice.html",
    "revision": "df5722f7551f62ae8ace6cb2fb0de58e"
  },
  {
    "url": "funny-pic-maker.html",
    "revision": "a626f3090e76ab4acf42e78488532cd1"
  },
  {
    "url": "gems.html",
    "revision": "bf940636b63738f7d566bb17c00aba6b"
  },
  {
    "url": "geoyell.html",
    "revision": "908f8adae1f232c611327945108761d8"
  },
  {
    "url": "gingerbread-runner-2.html",
    "revision": "2f85974cd8b2d788efcb4c583c25e75e"
  },
  {
    "url": "gingerbread-runner.html",
    "revision": "7f2787cd8a3284416826918b7e91bed7"
  },
  {
    "url": "goalkeeper-pro.html",
    "revision": "f9134bb0d93c53cb10de6af007016188"
  },
  {
    "url": "google-maps.html",
    "revision": "5b429cb9f6993ecbe1a5eeff01eb4e4c"
  },
  {
    "url": "gps-meter.html",
    "revision": "ea41cf2d2598cb3ccf1420ad93796834"
  },
  {
    "url": "gravity-box.html",
    "revision": "0ced30d65ca2963f0550d8ab678c98d6"
  },
  {
    "url": "guardians.html",
    "revision": "e60eaae4c525c11f4d247bfcce319684"
  },
  {
    "url": "guess-the-footballer.html",
    "revision": "d88c08f9154a16b7dac66ef8394aae09"
  },
  {
    "url": "gym-tracker.html",
    "revision": "ad09f4b79bad6064f6ab8ae4fa739004"
  },
  {
    "url": "habit-tracker.html",
    "revision": "2e8e9a0552e8d5cf6fd22252b89799ad"
  },
  {
    "url": "heart-rate-monitor.html",
    "revision": "23df0cf96838ec5d4908a1e756ec7e5c"
  },
  {
    "url": "hippo-stunt.html",
    "revision": "1d48300be86e8dda38bff35f821a53c6"
  },
  {
    "url": "home-fitness.html",
    "revision": "82782404e35b567dc75548c7c66d2d55"
  },
  {
    "url": "home-run.html",
    "revision": "5bf8268dfb2580371f211614a9464d13"
  },
  {
    "url": "html5-editor.html",
    "revision": "5ae7a3a1d2c88c78e14f781872f2d44d"
  },
  {
    "url": "hunting-birds-challenge.html",
    "revision": "a89b52437340c3a21df3c394f7cef937"
  },
  {
    "url": "ice-cream-slots.html",
    "revision": "e446245738c320d0c15a16a74d6b0aec"
  },
  {
    "url": "images/Arrow.svg",
    "revision": "6f20d7bac3c34ff69db0eb6c93afb731"
  },
  {
    "url": "images/ArrowLeft.svg",
    "revision": "f1c2f2e215c2e908face42a9689cdbe5"
  },
  {
    "url": "images/backward-10.png",
    "revision": "73f863d905e4fc41d4a3178959e53228"
  },
  {
    "url": "images/backward-10.svg",
    "revision": "f913dd39076007963007fd2b608eda49"
  },
  {
    "url": "images/forward-10.png",
    "revision": "27797df41ae23ec0f4eacf4a37d93a2c"
  },
  {
    "url": "images/forward-10.svg",
    "revision": "42c0730061fe60208eec515fef02b86e"
  },
  {
    "url": "images/ic_Kobi_112.png",
    "revision": "d13a4630ce79fe2e6649d2e6c40279bc"
  },
  {
    "url": "images/ic_Kobi_56.png",
    "revision": "4cec8cf38316cbbe9a1286cbe83faa17"
  },
  {
    "url": "images/icon128x128.png",
    "revision": "2c2c8369c70971e0b8347b354c7b5e5b"
  },
  {
    "url": "images/Kobi_Favicon.png",
    "revision": "dbe9a409b0461fc68266745b37e7d452"
  },
  {
    "url": "images/Kobi_Logo.svg",
    "revision": "4ce556e56938ae5207191f626089263e"
  },
  {
    "url": "images/logo_128.png",
    "revision": "a1b72d02cea603057cb78c1e8f1dad3c"
  },
  {
    "url": "images/love.png",
    "revision": "bbf313653bb87d99efc4c72bcd28b36e"
  },
  {
    "url": "images/rating-small.png",
    "revision": "8c2c4947e0257889a68b66449f077727"
  },
  {
    "url": "images/rating.png",
    "revision": "09323f76fbcaaf97b11f027b472d2a74"
  },
  {
    "url": "images/unlove.png",
    "revision": "16dfe7f4d955381f916d2cf186220b27"
  },
  {
    "url": "indeed-job-search.html",
    "revision": "dfcf2802d736145e04e29a271ab714f1"
  },
  {
    "url": "index.html",
    "revision": "e02f43909bccaae921a3fc004056de8b"
  },
  {
    "url": "instant-sound.html",
    "revision": "95432632a6ca9167e7037f82f9de0e7a"
  },
  {
    "url": "interview-questions.html",
    "revision": "082ad25b6aad0286286a0b62937c8d34"
  },
  {
    "url": "iptv-tube.html",
    "revision": "72afeb41ef66560e7a03ec0fb579fd6b"
  },
  {
    "url": "jet-fighter.html",
    "revision": "a6a92473ee9e0fc50948337d3c3f22de"
  },
  {
    "url": "jetpack-joyride.html",
    "revision": "80eaea47b40c5103aaf2a10d05063e93"
  },
  {
    "url": "jungle-plumber.html",
    "revision": "497c99ec99d87ab26d0058c3ed52978e"
  },
  {
    "url": "k-loan.html",
    "revision": "7d1ecb6e63c2df71bc81fd084026f2c5"
  },
  {
    "url": "k-music.html",
    "revision": "35d60b77085bacb8c30c8f33e7cd718e"
  },
  {
    "url": "k-pocket-browser.html",
    "revision": "f98fadb3f3ad1d7966e12024ed7a4445"
  },
  {
    "url": "k-todoist.html",
    "revision": "d4be81c832981538777d645018af8040"
  },
  {
    "url": "k-video-player.html",
    "revision": "3b4ad9f102c3ef3954d95620db1f836c"
  },
  {
    "url": "kairate.html",
    "revision": "bebd239a435f89ed93fb860d5392ae94"
  },
  {
    "url": "kaiweather.html",
    "revision": "7214122110688e0d490c9262a7b508ab"
  },
  {
    "url": "kinet-tv.html",
    "revision": "d787b973657e8cb954b1c19e107dc1a2"
  },
  {
    "url": "kloud-storage.html",
    "revision": "bc7b5dc1a7a57a328bb616470b487c23"
  },
  {
    "url": "language-tutor.html",
    "revision": "4f22a4da7f24ed2690c88edcfbc8d3ad"
  },
  {
    "url": "learn-a-language.html",
    "revision": "bf59982d21bb41efd3897205f89c55a3"
  },
  {
    "url": "learn-setswana.html",
    "revision": "e675b6e5dea3bc6a188a2e27d309c7ca"
  },
  {
    "url": "librivox-audiobooks-2.html",
    "revision": "456bbb36fbfce2ec323518b2b2973642"
  },
  {
    "url": "life-advices.html",
    "revision": "051af5bd156de6e79856b7a1b3247381"
  },
  {
    "url": "life-digital-skill.html",
    "revision": "ece1a58a5a4d9cef07832409b71bcf73"
  },
  {
    "url": "life-health.html",
    "revision": "71f77f6724a8fae724eed3f7556173ea"
  },
  {
    "url": "lights-out.html",
    "revision": "2884833f892896896c1145901a8822b1"
  },
  {
    "url": "live-tv.html",
    "revision": "09fbf85b190e33b280287f5f6aec0627"
  },
  {
    "url": "love-poetry.html",
    "revision": "a2cb22cf99d2b1286fb1588b05c96b8b"
  },
  {
    "url": "magic-ball.html",
    "revision": "7fa2643aefd9ff56216e0752a1a8b4cb"
  },
  {
    "url": "magical-8-ball.html",
    "revision": "f4f476c65d3f79526907749cecc7accb"
  },
  {
    "url": "manifest.json",
    "revision": "1285a440fa64fc809f2ea645a24bfd24"
  },
  {
    "url": "marble-mouse-3d.html",
    "revision": "bc97913a2262a9559f16f5525b9564bf"
  },
  {
    "url": "masquerade.html",
    "revision": "258c43f3c5680d207750a7b15d675515"
  },
  {
    "url": "massager.html",
    "revision": "15734baa12a6b98a9b48b6fa9ff398de"
  },
  {
    "url": "matches-puzzle.html",
    "revision": "e574503ed882b021cb532c8d89f92a14"
  },
  {
    "url": "math-challenge.html",
    "revision": "d6bd756264ffbdf58b687c8ad7ebfb46"
  },
  {
    "url": "math-training.html",
    "revision": "23d2636c616e9a3bc9b589db80bbc134"
  },
  {
    "url": "memories-of-the-dead.html",
    "revision": "5bc85fb2325d6da230cf4afe9aa0e918"
  },
  {
    "url": "memory-cards-2.html",
    "revision": "7be203130e19c6c0137995c78a03c847"
  },
  {
    "url": "memory-cards.html",
    "revision": "5f6437ad75f6e859505fa14b615ed75f"
  },
  {
    "url": "micrographia.html",
    "revision": "84cbbd6dc3a3016e7e5468edd9ac5a95"
  },
  {
    "url": "minesweeper-95.html",
    "revision": "f13e6c46c46c4fbabc6c068ffdfa5f9f"
  },
  {
    "url": "minesweeper.html",
    "revision": "abd9042afbc91562d4a89461006cb49d"
  },
  {
    "url": "mocha-air-quality.html",
    "revision": "d780a8269b83527d755b7e960486a099"
  },
  {
    "url": "mocha-chess.html",
    "revision": "c164e3fa59e3f01a509d05ad63dc2617"
  },
  {
    "url": "mocha-podcast.html",
    "revision": "0b28a3181df31a24f199d688e66b7bfc"
  },
  {
    "url": "mocha-radio.html",
    "revision": "693adc98ea1eacfc2663b072dff0248f"
  },
  {
    "url": "mocha-rss.html",
    "revision": "1112794a5a64bce2f87d606ac908f0af"
  },
  {
    "url": "monster-hell-jump.html",
    "revision": "5ecb2b3de88eae94b894bee845a94cf2"
  },
  {
    "url": "moon-monsters-jump.html",
    "revision": "0489f42bacf324c6de3dc31f89e0d9d0"
  },
  {
    "url": "moon-phase.html",
    "revision": "0461db02b0e70166079065bd80f597f2"
  },
  {
    "url": "music-world.html",
    "revision": "8a4a9fc48bb9aaa95db80fdf4a8faee1"
  },
  {
    "url": "muslim-pro.html",
    "revision": "b6479883eb7ae57c609ee97527340f43"
  },
  {
    "url": "my-ip-address.html",
    "revision": "f727fb5e64b233ad13e29b3831e4a639"
  },
  {
    "url": "nature-calm-sounds.html",
    "revision": "f310509d0f3d4f23d05917c151ed376d"
  },
  {
    "url": "neon-arcade-hockey.html",
    "revision": "c533efa9af19eb71ef1b744ce4dedfdb"
  },
  {
    "url": "netradio.html",
    "revision": "f6ab0f60a585a494da2b7f9958b4a15a"
  },
  {
    "url": "network-test.html",
    "revision": "805dc931cd3abf90e4da14d72b1153fb"
  },
  {
    "url": "news.html",
    "revision": "1992c6a5c87759916bab6d0905735a34"
  },
  {
    "url": "next-caltrain.html",
    "revision": "cd56e0317a7461d37b6c261e2a56c3c1"
  },
  {
    "url": "night-clock.html",
    "revision": "0a2f1d44bbc68ac158093e81337b309b"
  },
  {
    "url": "nihonoari.html",
    "revision": "d33044f0700c35b1985679b474e06bf9"
  },
  {
    "url": "nonogram.html",
    "revision": "0e4c7f6e21cb06334e04eeb195fcdd86"
  },
  {
    "url": "noob-draw.html",
    "revision": "81e7c3680e4a76a796246bdfdc9f34d5"
  },
  {
    "url": "o-map.html",
    "revision": "2f4d2d706031bdd5785d5e6ad050aeca"
  },
  {
    "url": "offline-dictionary.html",
    "revision": "11e021107fb912a1ee2325bae7bf5743"
  },
  {
    "url": "on-this-day.html",
    "revision": "ac883f9c1a296693bf5e9a242b8ceb7c"
  },
  {
    "url": "paint-by-number copy.html",
    "revision": "b81f8f4072017bb91408a018f3b69a69"
  },
  {
    "url": "paint-by-number.html",
    "revision": "58284bf8597fa0b1f20bdd5d50895508"
  },
  {
    "url": "pak-man.html",
    "revision": "55c49d8559b8fd0dbfa48e9b616b1330"
  },
  {
    "url": "parking-car-driver.html",
    "revision": "bd8f01061cb7a51392f0cc07d16acc64"
  },
  {
    "url": "password-generator.html",
    "revision": "3e2de203bbca811d25c443bf34b04d1e"
  },
  {
    "url": "password-vault.html",
    "revision": "7bd5b65d000f09cee1483bf1cc5a0bc1"
  },
  {
    "url": "period-tracker.html",
    "revision": "fac2ebb61c2ea0505f554d13ea19f033"
  },
  {
    "url": "periodic-table.html",
    "revision": "496a552fd49bf3d21e579bd0702bd92a"
  },
  {
    "url": "pet-hop.html",
    "revision": "261b3b63743f9fe3685f288f2b856dcb"
  },
  {
    "url": "phone-tools.html",
    "revision": "e41f884696d3beb06009fa454766c583"
  },
  {
    "url": "phonecopy.html",
    "revision": "41cb7fb1ed008eaaeb528bcd7d9bd941"
  },
  {
    "url": "photo-decorator.html",
    "revision": "df9c98ac5463f6655a3ea8eb780fe1a7"
  },
  {
    "url": "photo-zoom.html",
    "revision": "f93d0ce9a50a8d23de445f357fe221c7"
  },
  {
    "url": "piano-tiles.html",
    "revision": "ba3ff37ea9d685353a4df4f3ecbc7385"
  },
  {
    "url": "picture-quiz.html",
    "revision": "9d482bae93fe4967c6d7f62a8e22fc35"
  },
  {
    "url": "plank-workouts.html",
    "revision": "22aef2a6aa539e2d36ed849acca2a742"
  },
  {
    "url": "pocket-atm.html",
    "revision": "1c70bdd9d76a2c4b0ed5464647636715"
  },
  {
    "url": "podkast.html",
    "revision": "594c1dfd4e411d7fdabff18a33c12864"
  },
  {
    "url": "pomodoro.html",
    "revision": "13714d7ce139a74a55373fec1104ee16"
  },
  {
    "url": "pwa-manifest.webapp",
    "revision": "db2058bce50ee7fdaaa4554ea5449543"
  },
  {
    "url": "pyramid-of-memories.html",
    "revision": "9db1ad988c7e491e7f951fbd3e19f3e8"
  },
  {
    "url": "quicktodo.html",
    "revision": "0aa4f55cc06be805ac276a68f8f26814"
  },
  {
    "url": "radio-bd.html",
    "revision": "1c902fa42fa1d7c5fae0fbe27b381189"
  },
  {
    "url": "radio-waves.html",
    "revision": "190c9634c701cca9a6a9c740201dd589"
  },
  {
    "url": "rain-alarm.html",
    "revision": "c5b994a48597db1e80661ef85f86c818"
  },
  {
    "url": "rain-sounds.html",
    "revision": "0902c9a7394df50403bf64f0b672f733"
  },
  {
    "url": "randomly-chat.html",
    "revision": "dde47c150fbd553169d4bbd482073a40"
  },
  {
    "url": "razor-simulator.html",
    "revision": "813f0240acfbd2eb6728d1c3d1acf5a4"
  },
  {
    "url": "relaxing-massager.html",
    "revision": "c39446de7adc384eabcefe7a72ab686c"
  },
  {
    "url": "reversi.html",
    "revision": "a92a2a080aa82b9bc0fa1aaa5e6b6ec5"
  },
  {
    "url": "ringtones-pro.html",
    "revision": "a3470dead1a0c8a4b0afabd4991ce5e7"
  },
  {
    "url": "rub-my-belly-teddy.html",
    "revision": "0aa4f55cc06be805ac276a68f8f26814"
  },
  {
    "url": "sasha-caffeine.html",
    "revision": "cf529f9778404d1c3365269711aee723"
  },
  {
    "url": "sasha-emoji.html",
    "revision": "e4985b15292cd81145461f8d805a70c9"
  },
  {
    "url": "sasha-money.html",
    "revision": "388ebacbc6263250d00c92ec5454a3dc"
  },
  {
    "url": "sasha-morse-code.html",
    "revision": "3cd80b4db39868ee989a69a3847ee5fb"
  },
  {
    "url": "sashacalorie.html",
    "revision": "b059a201191afa7ef7a1921f38bbbdda"
  },
  {
    "url": "scientific-calculator.html",
    "revision": "a51db4097997e98d57d662a77b83dca8"
  },
  {
    "url": "scuba-diver-explorer.html",
    "revision": "d297215e0876fa282a81b8ae6e0eeb73"
  },
  {
    "url": "search.php",
    "revision": "bffb6b52658a847775bcccae6c4da7d4"
  },
  {
    "url": "searchContent.php",
    "revision": "0c2cfbf3a1c424d799a886248882a50e"
  },
  {
    "url": "searchController.php",
    "revision": "779cecbbafe458abb1743c5317d3913f"
  },
  {
    "url": "secret-journal.html",
    "revision": "e23d4a0c55721183cf7d0d2f9e9d4221"
  },
  {
    "url": "shareit.html",
    "revision": "b7f30869104af546a1cea609a6ba6eb0"
  },
  {
    "url": "shopping-list.html",
    "revision": "456d55f07f6d19644d1f3bef7ac8fba8"
  },
  {
    "url": "simple-file-manager.html",
    "revision": "4e3317372156e064d7e24a47b9fda1ef"
  },
  {
    "url": "simple-notes.html",
    "revision": "64691c3a505263c828d5035bb0d246a8"
  },
  {
    "url": "simple-video-maker.html",
    "revision": "24042fb52fe090ad8154b6037b3803af"
  },
  {
    "url": "simple-world-clock.html",
    "revision": "8b625f6988cc3e9f72efa8c16851e206"
  },
  {
    "url": "slant.html",
    "revision": "8ed17206d42ae5c09cc64ad7d98e47ff"
  },
  {
    "url": "sleep-fan.html",
    "revision": "08eec7fc81f763e57cffc9f891fe9f3d"
  },
  {
    "url": "sliding-blocks.html",
    "revision": "31748a5bb264440d3b983c98881a9098"
  },
  {
    "url": "socks-monster.html",
    "revision": "a6ac8e7865c65f53e8e2f5c02525916c"
  },
  {
    "url": "sorted-wallet.html",
    "revision": "ff327e0e49b657382534c9391c4608d2"
  },
  {
    "url": "sos-button.html",
    "revision": "c0f9a07bc91f364cd57b3b2eefd83273"
  },
  {
    "url": "sound-meter.html",
    "revision": "c8713f4f760255c0a643effbaec1b229"
  },
  {
    "url": "space-walk-3d.html",
    "revision": "8d08438b5ad11a220350557b99888d60"
  },
  {
    "url": "spanish-verbs.html",
    "revision": "fa5d1bc81343c92085d3c43f389e6f44"
  },
  {
    "url": "speedster-street.html",
    "revision": "6c922a0f9b90b3d7fd54c10a3f22507c"
  },
  {
    "url": "spelling-game.html",
    "revision": "90f8745d0f4ea66affab66848479c9e8"
  },
  {
    "url": "spin-the-bottle.html",
    "revision": "b461c0179c04817031a8456c1b5c4316"
  },
  {
    "url": "spin-the-wheel.html",
    "revision": "226871cb82bdc1334df333dc682969c7"
  },
  {
    "url": "star-wars-test.html",
    "revision": "ded4e4a07cb31e81b590e14ea5bda313"
  },
  {
    "url": "subtitle-downloader.html",
    "revision": "8323d7caa6919eb76bfd05fa2705ca60"
  },
  {
    "url": "sultan-gem-match-2.html",
    "revision": "ba3acff1e42a64db0dd5ef2da00b9056"
  },
  {
    "url": "sultan-gem-match.html",
    "revision": "b5a5b6b5d7800bc552c87ce80d54aaa3"
  },
  {
    "url": "sun-compass.html",
    "revision": "6b4920e50bb9881723906e3d09f2553e"
  },
  {
    "url": "sunset-sunrise.html",
    "revision": "5e487b6094b1ae6effb19c8ca449d76d"
  },
  {
    "url": "super-charrio-kart.html",
    "revision": "d7b5b48639ba9b4f1d5fe9f950dc82a5"
  },
  {
    "url": "survivor.html",
    "revision": "f3659c4cb8072f4fad760e22aa47106f"
  },
  {
    "url": "talking-clock.html",
    "revision": "0b329dac8291ae02f4ceafc87af2d465"
  },
  {
    "url": "talking-hamster.html",
    "revision": "55b6a717df5b9a296fd720c3462083e3"
  },
  {
    "url": "tank-shooting-duels.html",
    "revision": "6e58552c8c07483967fcaf4a78a0b999"
  },
  {
    "url": "tank-war-survival.html",
    "revision": "d6fbe531b7997cc51722758916e4e9d8"
  },
  {
    "url": "tennis-is-war.html",
    "revision": "16483ea15913deac95736c290539b5c7"
  },
  {
    "url": "text-to-speech.html",
    "revision": "b6a34ffae7772ce297c726dd799af080"
  },
  {
    "url": "the-economy.html",
    "revision": "ed9e15171634d8d0489731ae0538664d"
  },
  {
    "url": "the-movies-database.html",
    "revision": "a1a133bf4cc9388ef199fe5bc83ecdc6"
  },
  {
    "url": "tic-tac-toe.html",
    "revision": "a61ca03c475178b4571ca098a1cdd777"
  },
  {
    "url": "timberman-tree-cut.html",
    "revision": "09e31451df92108e80452c623e8f5411"
  },
  {
    "url": "topo-map.html",
    "revision": "b545200d442f663b70ebcccc190a37b4"
  },
  {
    "url": "tower-block.html",
    "revision": "f4a765dd572510da32d7aa9553d2c036"
  },
  {
    "url": "toy-brick-breaker.html",
    "revision": "8eccad9f5a97f05eecd50d13205b7803"
  },
  {
    "url": "transferbynet.html",
    "revision": "613423bb08ecd41a16b7fea5826540cc"
  },
  {
    "url": "treasure-hunter.html",
    "revision": "2543aa9da96dbfc35b1b6c7c79c50546"
  },
  {
    "url": "tweetfit.html",
    "revision": "4b9940432e36bd5e495c8502166291e4"
  },
  {
    "url": "twitter.html",
    "revision": "057279dc3311e9c01133da6169ada430"
  },
  {
    "url": "txt-msgs.html",
    "revision": "cbe2579f46b527b79299bb16b005c890"
  },
  {
    "url": "u-dictionary.html",
    "revision": "a1f405ae94fa70e6f9b794c21fbfe64a"
  },
  {
    "url": "uc-browser.html",
    "revision": "c7e2239f22792bee971485982e964cc6"
  },
  {
    "url": "unit-converter-pro-2.html",
    "revision": "324b707762f6b6cfc8ef0bd27c09e7ef"
  },
  {
    "url": "unit-converter-pro.html",
    "revision": "43196430c81f7196e2d11caffecc6e6f"
  },
  {
    "url": "video-player-pro.html",
    "revision": "5c98cea90bfba8721888f4ed9c4d9ab3"
  },
  {
    "url": "virtual-candle.html",
    "revision": "54d90476aaa8c1d8a092d3cec4e625d0"
  },
  {
    "url": "virus-info-by-kosmos.html",
    "revision": "b1dc101dfd05e97473cd1d8f9baa60ca"
  },
  {
    "url": "vitaguide.html",
    "revision": "5c820e4c5e795193ba47340a2788e51d"
  },
  {
    "url": "voice-recorder.html",
    "revision": "3bd7858416bab4664573739b0f362bb4"
  },
  {
    "url": "voiceping.html",
    "revision": "f8fed9df02e2ecfc85909fbcc9a5eca4"
  },
  {
    "url": "water-reminder.html",
    "revision": "abc677a33575da0400d59250e3087304"
  },
  {
    "url": "web-novel.html",
    "revision": "964adb44d332b690768f6052aebbd29f"
  },
  {
    "url": "whack-a-mole.html",
    "revision": "40b9bccdedec7aa8956481e8f366bf9f"
  },
  {
    "url": "whatsapp.html",
    "revision": "8e0a0efbaf821ad80f2e00c5a5a88f82"
  },
  {
    "url": "where-am-i-2.html",
    "revision": "97382180bdffb5b2e4fff767627ecf73"
  },
  {
    "url": "wikihow.html",
    "revision": "b0b18a85ce801917b65eb8f499d58eb5"
  },
  {
    "url": "wikipedia-2.html",
    "revision": "d4f37bd06200067d302a6c138d1aeb61"
  },
  {
    "url": "wikipedia.html",
    "revision": "d1feebcb0ad1089215fdb3270146f780"
  },
  {
    "url": "wizard-adventure.html",
    "revision": "cff6f95084bfb7a739a58592030662a3"
  },
  {
    "url": "word-of-the-day.html",
    "revision": "4bd5af15b7f21a48729e15ff8edf0b90"
  },
  {
    "url": "wordle copy.html",
    "revision": "704adcdb46e8de25de379ff9c376ba67"
  },
  {
    "url": "wordle.html",
    "revision": "8782e6279c1f6856d88ce10099bda790"
  },
  {
    "url": "world-of-hue.html",
    "revision": "70ea79c037741edb27897371acd25127"
  },
  {
    "url": "worldreader.html",
    "revision": "1676f0f7dd500976cb35e08506e993bf"
  },
  {
    "url": "wp-content/themes/spwa2/icons/ic_Kobi_112.png",
    "revision": "d13a4630ce79fe2e6649d2e6c40279bc"
  },
  {
    "url": "xender.html",
    "revision": "2be2ac4a79efbd87aa18cff69894c25d"
  },
  {
    "url": "xlsx-reader.html",
    "revision": "79902e9ec1b9882121de666963f77432"
  },
  {
    "url": "yoga-poses.html",
    "revision": "477ca23bd73aaa436c4476758b45c106"
  },
  {
    "url": "youtube.html",
    "revision": "e9e1de4c5bf5b6cd7cdaf414ebec59f7"
  },
  {
    "url": "zap-reddit-client.html",
    "revision": "f63ca1fe3d567426feda4e73185316df"
  },
  {
    "url": "zap-thesaurus.html",
    "revision": "f38603bc60d70b5919c0f479cf94ccec"
  },
  {
    "url": "ziggurat-escape.html",
    "revision": "5d597ee749f92f8ed6f258a7b7086b3b"
  },
  {
    "url": "zip-lite.html",
    "revision": "faff8abd9edd20751375e3756b4ac8ea"
  }
], {
  "ignoreURLParametersMatching": [/^utm_/, /^fbclid$/]
});








